// components/PublishPackageModal.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';

const PublishPackageModal = ({ row, onClose, refresh }) => {
    const [packageUrl, setPackageUrl] = useState('');

    const handleSubmit = async () => {
        const payload = { PublishPackageUrl: packageUrl };

        try {
            const res = await fetch(`https://prod.appstudioltts.com/api/linkstateupdate/updatedata/${row._id}`, {
                method: 'PUT',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                toast.success("Package URL submitted");
                refresh();
                onClose();
            } else {
                toast.error("Failed to submit URL");
            }
        } catch (err) {
            console.error(err);
            toast.error("Error submitting URL");
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[90%] max-w-lg">
                <h2 className="text-lg font-semibold mb-4">Submit Package URL</h2>
                <input
                    className="w-full border rounded p-2 mb-4"
                    placeholder="Enter NPM Package URL"
                    value={packageUrl}
                    onChange={(e) => setPackageUrl(e.target.value)}
                />
                <div className="flex justify-end gap-2">
                    <button className="bg-gray-300 px-4 py-2 rounded" onClick={onClose}>Cancel</button>
                    <button className="bg-blue-600 text-white px-4 py-2 rounded" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default PublishPackageModal;
